// Modules
import React from 'react'
import { useHistory } from 'react-router-dom'

// Application
import { useAnalytics, useActiveCIPOrphanHook } from 'hooks'
import { Analytics, ROUTES_PATH } from 'constants/index'

// Components
import { Header, TemplateContainer } from 'components'
import { GenderForm, GenderInitial } from 'components/Presenters/Gender'

export const NEWCIPBiologicalSex: React.VFC = () => {
    const history = useHistory()
    const { cpf, setBiologicalSex, hasMounted, biologicalSex } = useActiveCIPOrphanHook()

    const shouldRedirect = !cpf

    useAnalytics(Analytics.ActivateAccountCipOrphan.NewAccountBiologicSex, !shouldRedirect)

    if (!hasMounted) {
        return null
    }

    if (shouldRedirect) {
        history.push(ROUTES_PATH.SIGN_UP_REGISTER_ACTIVATION_CPF)
        return null
    }

    const handleSubmit = async (values: GenderInitial) => {
        await setBiologicalSex(values.biologicalSex)
        history.push(ROUTES_PATH.SIGN_UP_NEW_CIP_CREATE_PASSWORD)
    }

    return (
        <TemplateContainer>
            <Header subtitle="Selecione uma das opções abaixo." title="Qual é o seu sexo biológico?" />
            <GenderForm handleSubmit={handleSubmit} initialValues={{ biologicalSex: biologicalSex || '' }} />
        </TemplateContainer>
    )
}
